export default __webpack_public_path__ + "static/media/seven.ab4cac1b.svg";